<template>
  <div class="page-container">
    <a-spin :spinning="loading" size="large" tip="Loading...">
      <andon-header
        :clock-item="clockItem"
        :current-time="currentTime"
        @clickCategory="showCategoryDetailModal"
        @clickAllSummary="openAndonSummary"
      ></andon-header>
      <andon-content
        class="spv-content"
        :overview-data="andonTypeItems"
        @onPreviousClick="previousClick"
        @onNextClick="nextClick"
        @colClick="showCategoryDetailModal"
        @showAndonSummary="openAndonSummary"
      ></andon-content>
    </a-spin>
    <div class="footer-placeholder"></div>
  </div>
  <a-modal
    v-model:visible="visible"
    :title="detailModal.title"
    width="80%"
    wrap-class-name="has-table-full-modal"
    @cancel="onModalCancel"
  >
    <template #footer>
      <a-button @click="modalRefresh" :loading="refreshBtnLoading">
        <template #icon>
          <undo-outlined />
        </template>
        Refresh
      </a-button>
      <a-button type="primary" @click="onModalCancel">
        <template #icon>
          <close-outlined />
        </template>
        Close
      </a-button>
    </template>
    <category-table
      :is-open="visible"
      :current-params="currentParams"
      v-if="currentType === 1"
      ref="andonCategoryTable"
    ></category-table>
    <summary-table
      :page-params="pageParams"
      :is-open="visible"
      ref="andonSummaryTable"
      v-else
    ></summary-table>
  </a-modal>
</template>
<script>
  import andonHeader from './andon-header'
  import andonContent from './andon-content'
  import { mapGetters } from 'vuex'
  import { getPageData, getClo } from '@/api/andon-overview'
  import { message } from 'ant-design-vue'
  import categoryTable from './category-table.vue'
  import summaryTable from './summary-table.vue'
  import { CloseOutlined, UndoOutlined } from '@ant-design/icons-vue'
  export default {
    components: {
      andonHeader,
      andonContent,
      categoryTable,
      summaryTable,
      CloseOutlined,
      UndoOutlined,
    },
    data() {
      return {
        loading: false,
        page: 0,
        total: 1,
        scrollDelay: 150000,
        refreshDelay: 10000,
        isAutoScroll: false,
        andonTypeItems: [],
        clockItem: [],
        currentTime: new Date() * 1,
        initLoop: null,
        initAndonOverviewLoop: null,
        // 弹层
        visible: false,
        detailModal: {
          title: 'Surgery Andon Details(All Category)',
        },
        currentParams: {},
        currentType: 1, // 1代表是detail,2代表打开的是 summary
        refreshBtnLoading: false,
        currentSummaryParams: {},
        pageParams: {
          id: this.page,
          uiid: this.$route.params.id,
        },
      }
    },
    computed: {
      ...mapGetters({
        branch: 'user/currentSystem',
      }),
    },
    watch: {
      scrollDelay: {
        handler() {
          if (this.isAutoScroll) {
            clearInterval(this.initAndonOverviewLoop)
            this.initAndonOverviewLoop = setInterval(
              this.pageLoad,
              this.scrollDelay
            )
          }
        },
        immediate: true,
      },
      refreshDelay: {
        handler() {
          clearInterval(this.initLoop)
          this.initLoop = setInterval(() => {
            this.getAndonMainData(false)
            this.getAndonClockData()
            if (this.refreshDelay > this.scrollDelay) {
              //如果轮循时间大于滚屏时间就没有必要再轮循了。
              clearInterval(this.initLoop)
            }
          }, this.refreshDelay)
        },
        immediate: true,
      },
    },
    created() {
      this.pageLoad(true)
    },
    mounted() {},
    unmounted() {
      clearInterval(this.initLoop)
      clearInterval(this.initAndonOverviewLoop)
    },
    methods: {
      async getAndonMainData(showLoading = false) {
        if (showLoading) {
          this.loading = true
        }
        const params = {
          id: this.page,
          uiid: this.$route.params.id,
        }
        try {
          const { body } = await getPageData(params)
          this.andonTypeItems = body.data
          this.isAutoScroll = body.pageConfig.isAutoScroll
          //更新初始化设置
          this.total = body.pageConfig.totalPages
          this.scrollDelay = body.pageConfig.scrollDelay
          this.refreshDelay = body.pageConfig.refreshDelay
          this.loading = false
        } catch (e) {
          this.loading = false
        }
      },
      async getAndonClockData() {
        const params = {
          id: this.page,
          uiid: this.$route.params.id,
        }
        const { body } = await getClo(params)
        this.clockItem = body.data
        this.currentTime = body.currentTime * 1
      },
      pageLoad(showLoading = false) {
        this.page++
        if (this.page > this.total - 1) {
          this.page = 0
        }
        this.getAndonMainData(showLoading)
        this.getAndonClockData()
      },
      previousClick() {
        if (this.page >= 1) {
          this.page--
          this.pageLoad(true)
        } else {
          message.warning('There are no more pages to display')
        }
      },
      nextClick() {
        if (this.page < this.total - 1) {
          this.page++
          this.pageLoad(true)
        } else {
          message.warning('There are no more pages to display')
        }
      },
      async modalRefresh() {
        this.refreshBtnLoading = true
        try {
          if (this.currentType === 1) {
            this.$refs.andonCategoryTable.refresh()
          } else {
            this.$refs.andonSummaryTable.refresh()
          }

          this.refreshBtnLoading = false
        } catch (e) {
          this.refreshBtnLoading = false
        }
      },
      async showCategoryDetailModal(item, isAllCategory) {
        const title = item.title || item.columnName || ''
        this.currentParams = {
          column: title,
          id: this.page,
          uiid: this.$route.params.id,
        }
        this.currentType = 1
        if (!isAllCategory) {
          this.currentParams.row = item.row
        } else {
          delete this.currentParams.row
        }

        this.visible = true
        this.detailModal.title = isAllCategory
          ? `${title} Andon Details(All Category)`
          : `${title}(${item.row}) Andon Details`
        clearInterval(this.initLoop)
        clearInterval(this.initAndonOverviewLoop)
      },
      onModalCancel() {
        this.visible = false
        this.pageLoad()
      },
      openAndonSummary(item) {
        this.currentType = 2
        const t = !item ? '(All Category)' : `(${item.andonCategoryName})`
        const b = this.branch * 1 === 0 ? 'BJ' : 'TJ'
        this.visible = true
        this.detailModal.title = `GEHC ${b} Plant Andon Summary ${t}`
        this.pageParams = {
          id: this.page,
          uiid: this.$route.params.id,
          row: item ? item.andonCategoryName : '',
        }
        clearInterval(this.initLoop)
        clearInterval(this.initAndonOverviewLoop)
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .page-container {
    font-family: GEInspira-Medium, 'GE Inspira Medium';
    height: calc(100vh - 32px);
    :deep(.ant-spin-spinning) {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%);
    }
  }
  .footer-placeholder {
    height: 10px;
    background: @subMaster;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>
<style lang="less">
  .has-table-full-modal {
    .ant-modal-body {
      padding: 0;
    }
  }
</style>
